<template>
  <v-layout row wrap>
    <v-dialog
      v-model="syncloading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by syncing FB Data
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card class="elevation-6">
        <v-btn @click="picMessage()" v-if="!embed" small absolute top right fab color="info" dark>
          <v-icon>sync</v-icon>
        </v-btn>
        <v-autocomplete
          :items="conversationFB"
          solo
          class="chatF"
          return-object
          clearable
          hide-selected
          :disabled="sending"
          item-text="text"
          v-model="selectedFBChat"
          label="Select A Contact"
          v-if="!embed"
        >
          <template slot-scope="{ item, selected }" slot="selection">
            <v-chip
              :selected="selected"
              color="#efefef"
              class="primary--text"
            >
              <v-avatar
                size="avatarSize"
                class="elevation-2"
                color="secondary"
              >
              </v-avatar>
              <span class="font-weight-black">{{item.number}}</span>
            </v-chip>
          </template>
          <template slot-scope="{item}" slot="item">
            <v-list-tile-avatar
              class="headline font-weight-light white--text"
              :color="item.need?'primary':'white'"
            >
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-black" >{{item.number}}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{item.status }}  |  {{ (item.need? 'Need Reply' : '')}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>language</v-icon>
            </v-list-tile-action>
          </template>
        </v-autocomplete>
        <v-layout row wrap>
          
          <v-flex xs12 md10 style="background-color: #f0f2f5;" RIGHTPANNEL>
            <div v-chat-scroll="{always: true, smooth: true}" :class="`${embed? 'embed-chat-container' : 'chat-container'}`">
              <v-layout row wrap>
                <v-flex  v-for="msg in chatMessages" :key="msg.timestamp + msg.idgen" :class="` ${(msg.own?'text-xs-right':'')}`" xs12>
                  <v-layout row wrap>
                    <v-flex xs12>
                    </v-flex>
                    <v-flex xs12>
                      <v-icon clas="cStat" size="15px" v-if="msg.sent && !msg.delivered">done</v-icon>
                      <v-icon clas="cStat" size="15px" v-if="msg.delivered && !msg.viewed">done_all</v-icon>
                      <v-icon clas="cStat" size="15px" v-if="msg.viewed" color="primary">done_all</v-icon>
                      <div :class="`chatBubble ${(msg.me ?'ownBub':'')}`" >
                          <v-tooltip top>
                            <div slot="activator" style="font-size:8px">
                              {{ new Date(parseInt(msg.timestamp)) .toLocaleString('en-GB') }} | {{msg.user}}</div>
                            <span>{{ new Date(parseInt(msg.timestamp)) .toLocaleString('en-GB') }}  | {{msg.user}}</span>
                          </v-tooltip>
                          <div v-if="msg.text">{{msg.text}}</div>
                          <div v-else-if="msg.attachments && msg.attachments.length">
                            <div v-for="(att, a) in msg.attachments" :key="'attach-' + a">
                              <img v-if="att.type == 'image' && att.payload" :src="att.payload.url"  width="100%">
                              <video width="100%"  controls  v-if="att.type == 'video' && att.payload">
                                <source :src="att.payload.url" >
                              </video>
                            </div>
                          </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex 
                  v-if="chatMessages.length != 0 
                  && !chatMessages[chatMessages.length-1].me 
                  && selectedFBChat.need" 
                  xs12 class="justify-center text-xs-center">
                  
                    <v-btn @click="markAsRead()" outline color="primary" dark>mark as read</v-btn>
                  
                </v-flex>
                <v-flex xs12 v-if="sender && !selectedFBChat.need" class="text-xs-center" style="font-size:11px;font-weight:bold;">
                  LAST MARK AS READ: {{ selectedFBChat.mark_as_read }}
                </v-flex>
                <v-flex xs12 v-if="sender" class="text-xs-center" style="font-size:11px;font-weight:bold;">
                  {{sender.page}} | {{sender.id}}
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <v-flex xs12 md2 pa-2 LEFTPANNEL>
            <v-layout row wrap>
              <v-flex xs12 pt-3 >
                Select a Status
                <v-autocomplete
                  :items="waStatuses"
                  v-model="selectedFBStatus"
                  label="Select a Status"
                  return-object
                  clearable
                  hide-details
                  append-outer-icon="add"
                  :loading="statusLoading"
                  :disabled="!selectedFBChat"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-btn 
                  :disabled="!selectedFBStatus || !selectedFBChat" 
                  @click="storeFBStatus()" 
                  outline 
                  color="primary" 
                  small 
                  block 
                  :loading="statusLoading"
                >save</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>   
        <div>
          <input
            type="file"
            style="display: none"
            ref="file"
            accept="csv/*"
            @change="onFilePicked"
          >
          <div v-if="imgURL" class="imagePreview">
            <div style="position:absolute;z-index:19000;">
              <v-btn @click="removeImage" color="error" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <div style="position:absolute;z-index:19000;right:0;">
              <v-btn @click="sendMessageApi()" color="success" icon>
                <v-icon>send</v-icon>
              </v-btn>
            </div>
            <img v-if="!imgURL.includes('mp4')" class="imageItself" :src="imgURL">
            <video v-else width="200"  controls>
              <source :src="imgURL" >
            </video>
          </div>
          <v-text-field 
            solo 
            :loading="loading"
            class="chatF"
            height="60"
            :disabled="imgURL ? true : null"
            :readonly="imgURL ? true : null"
            label="...." 
            v-model="sMessage"
            prepend-inner-icon="add_photo_alternate"
            @click:prepend-inner="addImage()"
            append-icon="send"
            @click:append="sendMessageApi()"
            @keyup.enter="sendMessageApi()"
          ></v-text-field>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import virtualList from 'vue-virtual-scroll-list'
import { storageRef, firebase, db, auth, store } from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {
  'Accept': 'application/json'
}


export default {
  components: {
    'virtual-list': virtualList,
  },
  data() {
    return {
      loading:true,
      sMessage:null,
      chatMessages:[],
      sender:{},
      imgURL:null,
      syncloading:false,
      selectedFBChat:null,
      waStatuses:[],
      selectedFBStatus:null,
      statusLoading:false,
      file: null,
      uploadURL: null,
      fileName:null,
      imgURLExt: null,

      
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    getWAStatuses(){
      db.ref(`wastatuses`).once('value')
      .then(x=>{
        let ss = x.val()
        for (const key in ss) {
          if (ss.hasOwnProperty(key)) {
            const s = ss[key];
            this.waStatuses.push(s.name)
          }
        }
      })
    },
    async storeFBStatus() {
      if(!this.selectedFBChat.key && !this.selectedFBStatus) return
      this.statusLoading = true

      await store.collection(`fbconversations`).doc(this.selectedFBChat.key)
      .update({
        status:this.selectedFBStatus
      })
      
      this.statusLoading = false
    },
    async loadItem(item){
      console.log(item)
      this.selectedFBChat = item
      this.selectedFBStatus = this.selectedFBChat.status
      let messages = await store.collection('fbconversations').doc(item.key).collection('messages')
      .get().then(x => x.docs.map(y => {return {...y.data(), key:y.id}}))
      console.log(messages)
      this.chatMessages = []
      this.chatMessages = messages.map(x=>{
        return  {
          ...x, 
          idgen:uuid(),
          own: x.me
        }
      }).sort((a,b)=> a.timestamp - b.timestamp)
      this.scrollToEnd()
      this.loading = false
    },
    addImage() {

    },
    async sendMessageApi() {
      this.loading = true
      let token = await db.ref(`settings/fb/${this.selectedFBChat.page_id}/token`).once('value').then(x=>x.val())
      let message = {
        recipient:{id:this.selectedFBChat.customer},
        messaging_type:'RESPONSE',
      }
      if(this.imgURL) {
        message.message = { attachment: {
            type:"image", 
            payload:{
              url: this.imgURL, 
              is_reusable:true
            }
          }
        }
      } else {
        message.message = {text:this.sMessage}
      }
      let b = await axios.post(`https://graph.facebook.com/v11.0/me/messages?access_token=${token}`, message).then(x=>x.data)
      let user = this.$props.userName ? this.$props.userName : 'system'
      console.log(b)
      await db.ref(`FBnuser/${b.message_id.slice(0, 20)}`).update({
        message_id: b.message_id,
        user
      })
      this.imgURL = null
      this.sMessage = null
      this.loading = false
    },
    markAsRead() {
    },
    addImage(){
      console.log('s')
      this.pickFile()
    },
    pickFile() {
      this.$refs.file.click()
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/ashyaat' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.uploadURL = downloadURL
          this.imgURL = downloadURL
          this.loading = false
        });
      });
    },
    onFilePicked (e) {
      this.loading = true
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          console.log(this.file)
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
        this.fileName = null
        this.uploadURL = null
      }
    },
    removeImage(){
      this.imgURL = null
      this.imgURLExt = null
    },
    scrollToEnd() {
      try {
        var container = document.querySelector(".chat-container") ? document.querySelector(".chat-container") : document.querySelector(".embed-chat-container");
        setTimeout(x=>{
          container.scrollTop = container.scrollHeight;
        }, 1000)
        this.scroll()
      } catch (error) {}
    },
    scroll () {
      try {
        document.querySelector(".chat-container").onscroll = () => {
          console.log(document.querySelector(".chat-container").scrollHeight)
        };
      } catch (error) {}
    },
  },
  props: {
    qitem: {
      default: false
    },
    userName: {
      required: true,
      default: 'user'
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
    embed: {
      default: false
    },
    item: {
      default: false
    },
    itemO: {
      default: false
    },
  },
  watch:{
    
   
  },
  computed:{
   
  },
  async created() {
    this.getWAStatuses()
    if(this.$props.embed) {
      this.loadItem(this.$props.item)
    }
    
  },
  mounted(){
    
  }
  
}
</script>

<style>
.chat-container {
  box-sizing: border-box;
  height: calc(100vh - 13.0rem);
  overflow-y: auto;
  padding: 10px;
  box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.65);
}
.embed-chat-container {
  box-sizing: border-box;
  height: 300px;
  overflow-y: auto;
  padding: 10px;
  box-shadow: inset 0px 0px 3px rgba(0, 0, 0, 0.65);
}
.chat-container::after {
  content: "";
  background-image: url("/bgchat.png");
  background-repeat: repeat;
  opacity: 0.09;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;   
}
.chatF .v-input__slot {
  margin-bottom:0 !important;
}
.chatF .v-text-field__details {
  display: none
}

.chatF .v-progress-linear {
  height: 5px !important;
}

.chatBubble {
  padding: 8px;
  background-color: #0084ff;
  color:white;
  border-radius: 10px;
  display: inline-block;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);
  max-width: 50%;
  word-wrap: break-word;
  margin-bottom: 4px;
  z-index: 2;   

}

.ownBub {
  background-color: #0084ff;
}
.ownMsg {
  text-align: right;
}

.cStat {
  margin-right: 6px !important;
}
.imagePreview {
  border-radius: 3px;
  bottom: 53px;
  width: 200px;
  position: absolute;
  z-index: 101010;
  right: 20px;
  box-shadow: 0 0 4px black;
}
.imageItself {
  width: 200px;
  border-radius: 3px;

}
</style>
